export class NblocksStorage {
  static KEY_PREFIX = "NB_";
  static setItem(key, value) {
    localStorage.setItem(this.KEY_PREFIX + key, value);
  }
  static getItem(key) {
    return localStorage.getItem(this.KEY_PREFIX + key);
  }
  static removeItem(key) {
    localStorage.removeItem(this.KEY_PREFIX + key);
  }
  static clear() {
    localStorage.clear();
  }
}